import { __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import { Box, Typography } from '@mui/material';
import React__default from 'react';

var SliderLabelValue = function (_a) {
    var labels = _a.labels, side = _a.side, _b = _a.max, max = _b === void 0 ? 100 : _b, _c = _a.min, min = _c === void 0 ? 0 : _c, _d = _a.value, value = _d === void 0 ? 0 : _d, labelFormat = _a.labelFormat, prefixId = _a.prefixId;
    var valueLabel = side === "start"
        ? labels.invertSliderValues
            ? max - value
            : min
        : labels.invertSliderValues
            ? value
            : max;
    var valueLabelStr = valueLabel.toString();
    if (labelFormat) {
        valueLabelStr = labelFormat(valueLabel);
    }
    else if (max === 100 && labelFormat !== null) {
        valueLabelStr = "".concat(valueLabel, "%");
    }
    return (React__default.createElement(Box, { display: "flex", flexDirection: "column", alignItems: side === "start" ? "flex-start" : "flex-end", minWidth: "44px" },
        React__default.createElement(Typography, { color: "neutral100", variant: "body2", sx: __assign({ position: "absolute", left: side === "start" ? 0 : "auto", right: side === "start" ? "auto" : 0 }, (labels.labelsAbove !== false ? { top: 0 } : { bottom: 0 })), id: prefixId && "".concat(prefixId, "-label") }, side === "start" ? labels.start : labels.end),
        React__default.createElement(Typography, { color: "neutral400", variant: "body2", id: prefixId && "".concat(prefixId, "-value") }, valueLabelStr)));
};

export { SliderLabelValue };
